var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home clearfix"},[_c('game-header'),_c('router-view',{attrs:{"name":"home"}}),_c('betslip-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }